module.exports = __webpack_public_path__ + "img/saving.6a4b8c72.svg";